// Mock data for Rooam Sports platform

export const mockSports = [
  { id: 'basketball', name: 'Basketball', icon: '🏀' },
  { id: 'volleyball', name: 'Volleyball', icon: '🏐' },
  { id: 'soccer', name: 'Soccer', icon: '⚽' },
  { id: 'lacrosse', name: 'Lacrosse', icon: '🥍' },
  { id: 'softball', name: 'Softball', icon: '🥎' },
  { id: 'football', name: 'Football', icon: '🏈' },
];

export const mockGames = [
  {
    id: 1,
    title: 'Eagles vs Hawks - Finals',
    sport: 'basketball',
    league: 'Youth Premier League',
    status: 'live',
    viewers: 1247,
    team1: { name: 'Eagles', score: 78, logo: 'E' },
    team2: { name: 'Hawks', score: 72, logo: 'H' },
    date: '2025-07-15T19:30:00',
    thumbnail: 'https://images.unsplash.com/photo-1546519638-68e109498ffc?w=800',
    videoId: 'gHMNZrdh6f4',
    views: 3420,
    duration: 'Live',
  },
  {
    id: 6,
    title: 'Beach FC Academy vs LA Galaxy Youth',
    sport: 'soccer',
    league: 'Beach Futbol Club Winter Classic',
    status: 'browse',
    viewers: 2156,
    team1: { name: 'Beach FC', score: 2, logo: 'BFC', color: '#00A4E4' },
    team2: { name: 'LA Galaxy', score: 1, logo: 'LAG', color: '#004694' },
    date: '2026-01-25T14:00:00',
    thumbnail: 'https://images.unsplash.com/photo-1574629810360-7efbbe195018?w=800',
    videoUrl: 'https://customer-assets.emergentagent.com/job_livestream-16/artifacts/cxbkinz5_IMG_3030%20%281%29.MOV',
    views: 4521,
    duration: 'Live',
    gameTime: "67'",
    half: '2nd Half',
    tournamentId: '35e330ea-96a4-48e4-8cbf-955fa07b0548',
  },
  {
    id: 7,
    title: 'San Diego Surf vs Real So Cal',
    sport: 'soccer',
    league: 'Beach Futbol Club Winter Classic',
    status: 'browse',
    viewers: 1834,
    team1: { name: 'SD Surf', score: 1, logo: 'SDS', color: '#0077B6' },
    team2: { name: 'Real SC', score: 1, logo: 'RSC', color: '#DC143C' },
    date: '2026-01-25T16:00:00',
    thumbnail: 'https://images.unsplash.com/photo-1579952363873-27f3bade9f55?w=800',
    videoUrl: 'https://customer-assets.emergentagent.com/job_livestream-16/artifacts/2euazfbf_163743.MP4',
    views: 3287,
    duration: 'Live',
    gameTime: "34'",
    half: '1st Half',
    tournamentId: '35e330ea-96a4-48e4-8cbf-955fa07b0548',
  },
  {
    id: 2,
    title: 'Thunderbolts vs Lightning',
    sport: 'volleyball',
    league: 'High School Championship',
    status: 'live',
    viewers: 892,
    team1: { name: 'Thunderbolts', score: 2, logo: 'T' },
    team2: { name: 'Lightning', score: 1, logo: 'L' },
    date: '2025-07-15T18:00:00',
    thumbnail: 'https://images.unsplash.com/photo-1612872087720-bb876e2e67d1?w=800',
    videoId: 'HEewvAkHca0',
    views: 1205,
    duration: 'Live',
  },
  {
    id: 3,
    title: 'Phoenix FC vs Dragons SC',
    sport: 'soccer',
    league: 'Academy Cup',
    status: 'replay',
    team1: { name: 'Phoenix FC', score: 3, logo: 'P' },
    team2: { name: 'Dragons SC', score: 2, logo: 'D' },
    date: '2025-07-14T16:00:00',
    thumbnail: 'https://images.unsplash.com/photo-1579952363873-27f3bade9f55?w=800',
    videoId: 'jp1xfZKw0d4',
    views: 5670,
    duration: '1:45:20',
  },
  {
    id: 4,
    title: 'Warriors vs Knights',
    sport: 'basketball',
    league: 'Regional Tournament',
    status: 'replay',
    team1: { name: 'Warriors', score: 85, logo: 'W' },
    team2: { name: 'Knights', score: 79, logo: 'K' },
    date: '2025-07-13T20:00:00',
    thumbnail: 'https://images.unsplash.com/photo-1608245449230-4ac19066d2d0?w=800',
    videoId: 'cpf2w3QWOKA',
    views: 8934,
    duration: '1:52:15',
  },
  {
    id: 5,
    title: 'Titans vs Rangers',
    sport: 'lacrosse',
    league: 'State Finals',
    status: 'upcoming',
    team1: { name: 'Titans', score: 0, logo: 'T' },
    team2: { name: 'Rangers', score: 0, logo: 'R' },
    date: '2025-07-16T17:30:00',
    thumbnail: 'https://images.unsplash.com/photo-1593766787879-e8c78e09cec5?w=800',
    videoId: '',
    views: 0,
    duration: 'Upcoming',
  },
];

export const mockAthletes = [
  {
    id: 1,
    name: 'Noah Taylor',
    sport: 'basketball',
    position: 'Point Guard',
    team: 'Eagles',
    age: 17,
    height: '6\'2"',
    number: 1,
    avatar: 'https://customer-assets.emergentagent.com/job_a7dcc5ab-3efc-44f0-a3e2-af78bfda65b9/artifacts/fzm8g1k9_IMG_9784.jpeg',
    stats: {
      ppg: 24.5,
      apg: 7.2,
      rpg: 4.8,
      fg: '48%',
    },
    highlights: 12,
    games: 25,
    verified: true,
  },
  {
    id: 2,
    name: 'Sarah Williams',
    sport: 'volleyball',
    position: 'Outside Hitter',
    team: 'Thunderbolts',
    age: 16,
    height: '5\'11"',
    number: 15,
    avatar: 'https://customer-assets.emergentagent.com/job_f4179c34-6cc2-42f7-b341-41bdd7c10fda/artifacts/jsjzwvhk_IMG_9790.jpeg',
    stats: {
      kills: 342,
      blocks: 89,
      aces: 67,
      digs: 234,
    },
    highlights: 8,
    games: 32,
    verified: true,
    claimable: true,
  },
  {
    id: 3,
    name: 'Khalis Benjamin',
    sport: 'soccer',
    position: 'Midfielder',
    team: 'Phoenix FC',
    age: 18,
    height: '5\'10"',
    number: 10,
    avatar: 'https://customer-assets.emergentagent.com/job_a7dcc5ab-3efc-44f0-a3e2-af78bfda65b9/artifacts/wqzlpj0d_IMG_6082.jpeg',
    stats: {
      goals: 15,
      assists: 22,
      passes: '87%',
      tackles: 145,
    },
    highlights: 15,
    games: 28,
    verified: true,
  },
  {
    id: 4,
    name: 'Jessica Martinez',
    sport: 'softball',
    position: 'Pitcher',
    team: 'Storm',
    age: 17,
    height: '5\'8"',
    number: 22,
    avatar: 'https://customer-assets.emergentagent.com/job_f4179c34-6cc2-42f7-b341-41bdd7c10fda/artifacts/23hnadms_IMG_9791.jpeg',
    stats: {
      era: '1.85',
      wins: 12,
      strikeouts: 156,
      saves: 8,
    },
    highlights: 10,
    games: 24,
    verified: false,
    claimable: true,
  },
  {
    id: 5,
    name: 'David Chen',
    sport: 'soccer',
    position: 'Striker',
    team: 'Dragons SC',
    age: 16,
    height: '5\'9"',
    number: 9,
    avatar: 'https://customer-assets.emergentagent.com/job_f4179c34-6cc2-42f7-b341-41bdd7c10fda/artifacts/rszuddbr_IMG_9789.webp',
    stats: {
      goals: 21,
      assists: 14,
      shots: 78,
      accuracy: '62%',
    },
    highlights: 18,
    games: 30,
    verified: false,
    claimable: true,
  },
  {
    id: 6,
    name: 'Gregory Nunn',
    sport: 'basketball',
    position: 'Shooting Guard',
    team: 'Hawks',
    age: 17,
    height: '6\'4"',
    number: 23,
    avatar: 'https://customer-assets.emergentagent.com/job_f4179c34-6cc2-42f7-b341-41bdd7c10fda/artifacts/14zsxd4p_IMG_1404.jpeg',
    stats: {
      ppg: 18.7,
      apg: 4.5,
      rpg: 5.2,
      fg: '45%',
    },
    highlights: 9,
    games: 22,
    verified: true,
  },
];

export const mockHighlights = [
  {
    id: 2,
    title: 'Sarah Williams - Game Winning Kill',
    athleteId: 2,
    gameId: 2,
    duration: '1:20',
    views: 8234,
    likes: 645,
    thumbnail: 'https://images.unsplash.com/photo-1612872087720-bb876e2e67d1?w=400',
    videoId: 'HEewvAkHca0',
    date: '2025-07-15',
  },
  {
    id: 3,
    title: 'Gregory Nunn - Game Highlights',
    athleteId: 6,
    gameId: 4,
    duration: '1:30',
    views: 5620,
    likes: 423,
    thumbnail: 'https://customer-assets.emergentagent.com/job_f4179c34-6cc2-42f7-b341-41bdd7c10fda/artifacts/14zsxd4p_IMG_1404.jpeg',
    videoUrl: 'https://customer-assets.emergentagent.com/job_f4179c34-6cc2-42f7-b341-41bdd7c10fda/artifacts/2wsqbxo6_IMG_2018.mov',
    date: '2025-07-16',
  },
  {
    id: 4,
    title: 'Khalis Benjamin - Midfield Masterclass',
    athleteId: 3,
    gameId: 3,
    duration: '2:15',
    views: 7890,
    likes: 567,
    thumbnail: 'https://images.unsplash.com/photo-1579952363873-27f3bade9f55?w=400',
    videoUrl: 'https://customer-assets.emergentagent.com/job_f4179c34-6cc2-42f7-b341-41bdd7c10fda/artifacts/8kd7i7zj_IMG_0801.mov',
    date: '2025-07-14',
  },
  {
    id: 5,
    title: 'Khalis Benjamin - Game Day Highlights',
    athleteId: 3,
    gameId: 3,
    duration: '1:40',
    views: 9450,
    likes: 723,
    thumbnail: 'https://images.unsplash.com/photo-1574629810360-7efbbe195018?w=400',
    videoUrl: 'https://customer-assets.emergentagent.com/job_f4179c34-6cc2-42f7-b341-41bdd7c10fda/artifacts/04thfflh_Jan-2-2026-1767338368_0140162.mov',
    date: '2025-07-16',
  },
  {
    id: 6,
    title: 'Noah Taylor - Clutch Plays Compilation',
    athleteId: 1,
    gameId: 1,
    duration: '1:45',
    views: 15680,
    likes: 1234,
    thumbnail: 'https://images.unsplash.com/photo-1546519638-68e109498ffc?w=400',
    videoUrl: 'https://customer-assets.emergentagent.com/job_f4179c34-6cc2-42f7-b341-41bdd7c10fda/artifacts/2hhzfkfz_SnapInsta.to_AQNTRfISPZtkjCetigIw1GefZAWC3Eddizok9EZ7xXBdzMQMSxRuG6ywCbaTW2Fu-y7nj_BQIraAK1KV3cVaLFU2owG0jqU12--dF6s.mp4',
    date: '2025-07-16',
  },
];

export const mockAIAnalysis = {
  gameId: 1,
  processedAt: '2025-07-15T19:45:00',
  summary: 'High-intensity matchup with strong offensive performance from both teams. Eagles dominated the third quarter with a 12-2 run.',
  keyMoments: [
    { time: '12:45 Q2', description: 'Noah Taylor - 3-pointer with contact', impact: 'high' },
    { time: '08:23 Q3', description: 'Eagles 12-2 scoring run', impact: 'high' },
    { time: '03:12 Q4', description: 'Game-tying steal and layup', impact: 'high' },
  ],
  playerPerformance: [
    { playerId: 1, name: 'Noah Taylor', rating: 9.2, highlights: 8, efficiency: 0.87 },
    { playerId: 2, name: 'Tyler Davis', rating: 7.8, highlights: 4, efficiency: 0.72 },
    { playerId: 3, name: 'James Wilson', rating: 8.5, highlights: 6, efficiency: 0.81 },
  ],
  teamStats: {
    eagles: {
      fieldGoal: '48%',
      threePoint: '38%',
      freeThrow: '82%',
      rebounds: 42,
      assists: 24,
      turnovers: 13,
    },
    hawks: {
      fieldGoal: '45%',
      threePoint: '33%',
      freeThrow: '78%',
      rebounds: 38,
      assists: 21,
      turnovers: 15,
    },
  },
};

export const mockEvents = [
  {
    id: 1,
    name: 'Gary Charles Hoops Classic',
    sport: 'basketball',
    date: '2026-01-03T12:00:00',
    endDate: '2026-01-04T12:00:00',
    location: 'Chaminade High School & Saint Dominic High School',
    teams: 20,
    games: 19,
    status: 'upcoming',
  },
  {
    id: 2,
    name: 'Summer Championship Finals',
    sport: 'basketball',
    date: '2025-07-20',
    location: 'Metro Sports Arena',
    teams: 8,
    games: 12,
    status: 'upcoming',
  },
  {
    id: 3,
    name: 'Regional Volleyball Tournament',
    sport: 'volleyball',
    date: '2025-07-22',
    location: 'Convention Center',
    teams: 16,
    games: 24,
    status: 'upcoming',
  },
  {
    id: 4,
    name: 'Youth Soccer Showcase',
    sport: 'soccer',
    date: '2025-07-25',
    location: 'City Stadium Complex',
    teams: 12,
    games: 18,
    status: 'upcoming',
  },
];

// Mock data for Gary Charles Hoops Classic games
export const mockEventGames = [
  // Day 1 - Saturday, January 3rd - CHAMINADE (311 Jericho Tpke, Mineola NY)
  {
    id: 1,
    eventId: 1,
    day: 1,
    gameNumber: 1,
    time: '9:30 AM',
    location: 'Chaminade',
    team1: { name: 'Floral Park', score: 0, record: '' },
    team2: { name: 'Port Washington', score: 0, record: '' },
    status: 'upcoming',
    videoUrl: '/game-video.mp4',
    title: 'Floral Park vs Port Washington',
  },
  {
    id: 2,
    eventId: 1,
    day: 1,
    gameNumber: 2,
    time: '11:00 AM',
    location: 'Chaminade',
    team1: { name: 'Martin Van Buren', score: 0, record: '' },
    team2: { name: 'William Floyd', score: 0, record: '' },
    status: 'upcoming',
    videoUrl: '/game-video.mp4',
    title: 'Martin Van Buren vs William Floyd',
  },
  {
    id: 3,
    eventId: 1,
    day: 1,
    gameNumber: 3,
    time: '12:30 PM',
    location: 'Chaminade',
    team1: { name: 'Nazareth Girls', score: 0, record: '' },
    team2: { name: 'Baldwin Girls', score: 0, record: '' },
    status: 'upcoming',
    videoUrl: '/game-video.mp4',
    title: 'Nazareth Girls vs Baldwin Girls',
  },
  {
    id: 4,
    eventId: 1,
    day: 1,
    gameNumber: 4,
    time: '2:00 PM',
    location: 'Chaminade',
    team1: { name: 'Nazareth Boys', score: 0, record: '' },
    team2: { name: 'Thomas Jefferson', score: 0, record: '' },
    status: 'upcoming',
    videoUrl: '/game-video.mp4',
    title: 'Nazareth Boys vs Thomas Jefferson',
  },
  {
    id: 5,
    eventId: 1,
    day: 1,
    gameNumber: 5,
    time: '3:30 PM',
    location: 'Chaminade',
    team1: { name: 'Uniondale', score: 0, record: '' },
    team2: { name: 'Baldwin', score: 0, record: '' },
    status: 'upcoming',
    videoUrl: '/game-video.mp4',
    title: 'Uniondale vs Baldwin',
  },
  {
    id: 6,
    eventId: 1,
    day: 1,
    gameNumber: 6,
    time: '5:00 PM',
    location: 'Chaminade',
    team1: { name: 'Cardozo', score: 0, record: '' },
    team2: { name: 'Half Hollow East', score: 0, record: '' },
    status: 'upcoming',
    videoUrl: '/game-video.mp4',
    title: 'Cardozo vs Half Hollow East',
  },
  {
    id: 7,
    eventId: 1,
    day: 1,
    gameNumber: 7,
    time: '6:30 PM',
    location: 'Chaminade',
    team1: { name: 'St. Raymond', score: 0, record: '' },
    team2: { name: 'Chaminade', score: 0, record: '' },
    status: 'upcoming',
    videoUrl: '/game-video.mp4',
    title: 'St. Raymond vs Chaminade',
  },
  {
    id: 8,
    eventId: 1,
    day: 1,
    gameNumber: 8,
    time: '8:00 PM',
    location: 'Chaminade',
    team1: { name: 'Susan E. Wagner', score: 0, record: '' },
    team2: { name: 'Valley Stream Central', score: 0, record: '' },
    status: 'upcoming',
    videoUrl: '/game-video.mp4',
    title: 'Susan E. Wagner vs Valley Stream Central',
  },
  // Day 1 - Saturday, January 3rd - ST DOMINIC (110 Anstice St, Oyster Bay)
  {
    id: 9,
    eventId: 1,
    day: 1,
    gameNumber: 9,
    time: '11:00 AM',
    location: 'St. Dominic',
    team1: { name: 'Sacred Heart Girls', score: 0, record: '' },
    team2: { name: 'Syosset Girls', score: 0, record: '' },
    status: 'upcoming',
    videoUrl: '/game-video.mp4',
    title: 'Sacred Heart Girls vs Syosset Girls',
  },
  {
    id: 10,
    eventId: 1,
    day: 1,
    gameNumber: 10,
    time: '12:30 PM',
    location: 'St. Dominic',
    team1: { name: 'Brentwood', score: 0, record: '' },
    team2: { name: 'Malverne', score: 0, record: '' },
    status: 'upcoming',
    videoUrl: '/game-video.mp4',
    title: 'Brentwood vs Malverne',
  },
  {
    id: 11,
    eventId: 1,
    day: 1,
    gameNumber: 11,
    time: '2:00 PM',
    location: 'St. Dominic',
    team1: { name: 'Forest Hills', score: 0, record: '' },
    team2: { name: 'St. Dominic', score: 0, record: '' },
    status: 'upcoming',
    videoUrl: '/game-video.mp4',
    title: 'Forest Hills vs St. Dominic',
  },
  {
    id: 12,
    eventId: 1,
    day: 1,
    gameNumber: 12,
    time: '3:30 PM',
    location: 'St. Dominic',
    team1: { name: 'Westbury', score: 0, record: '' },
    team2: { name: 'LuHi Regional', score: 0, record: '' },
    status: 'upcoming',
    videoUrl: '/game-video.mp4',
    title: 'Westbury vs LuHi Regional',
  },
  {
    id: 13,
    eventId: 1,
    day: 1,
    gameNumber: 13,
    time: '5:00 PM',
    location: 'St. Dominic',
    team1: { name: 'Sewanhaka', score: 0, record: '' },
    team2: { name: 'Wyandanch', score: 0, record: '' },
    status: 'upcoming',
    videoUrl: '/game-video.mp4',
    title: 'Sewanhaka vs Wyandanch',
  },
  {
    id: 14,
    eventId: 1,
    day: 1,
    gameNumber: 14,
    time: '6:30 PM',
    location: 'St. Dominic',
    team1: { name: 'Masters School', score: 0, record: '' },
    team2: { name: 'Elmont', score: 0, record: '' },
    status: 'upcoming',
    videoUrl: '/game-video.mp4',
    title: 'Masters School vs Elmont',
  },
  // Day 2 - Sunday, January 4th - CHAMINADE (311 Jericho Tpke, Mineola NY)
  {
    id: 15,
    eventId: 1,
    day: 2,
    gameNumber: 15,
    time: '12:30 PM',
    location: 'Chaminade',
    team1: { name: 'Stony Brook', score: 0, record: '' },
    team2: { name: 'St. Anthony\'s', score: 0, record: '' },
    status: 'upcoming',
    videoUrl: '/game-video.mp4',
    title: 'Stony Brook vs St. Anthony\'s',
  },
  {
    id: 16,
    eventId: 1,
    day: 2,
    gameNumber: 16,
    time: '2:00 PM',
    location: 'Chaminade',
    team1: { name: 'St. Dominic', score: 0, record: '' },
    team2: { name: 'Bay Shore', score: 0, record: '' },
    status: 'upcoming',
    videoUrl: '/game-video.mp4',
    title: 'St. Dominic vs Bay Shore',
  },
  {
    id: 17,
    eventId: 1,
    day: 2,
    gameNumber: 17,
    time: '3:30 PM',
    location: 'Chaminade',
    team1: { name: 'LuHi Regional', score: 0, record: '' },
    team2: { name: 'Southampton', score: 0, record: '' },
    status: 'upcoming',
    videoUrl: '/game-video.mp4',
    title: 'LuHi Regional vs Southampton',
  },
  {
    id: 18,
    eventId: 1,
    day: 2,
    gameNumber: 18,
    time: '5:00 PM',
    location: 'Chaminade',
    team1: { name: 'Holy Cross', score: 0, record: '' },
    team2: { name: 'Chaminade', score: 0, record: '' },
    status: 'upcoming',
    videoUrl: '/game-video.mp4',
    title: 'Holy Cross vs Chaminade',
  },
  {
    id: 19,
    eventId: 1,
    day: 2,
    gameNumber: 19,
    time: '6:30 PM',
    location: 'Chaminade',
    team1: { name: 'Roslyn', score: 0, record: '' },
    team2: { name: 'Holy Trinity', score: 0, record: '' },
    status: 'upcoming',
    videoUrl: '/game-video.mp4',
    title: 'Roslyn vs Holy Trinity',
  },
];

export const mockUserRoles = [
  { id: 'athlete', name: 'Athlete/Player', description: 'Access your games, stats, and build your profile' },
  { id: 'coach', name: 'Coach', description: 'Analyze team performance and scout talent' },
  { id: 'parent', name: 'Parent/Family', description: 'Watch and share your athlete\'s moments' },
  { id: 'scout', name: 'Scout/Recruiter', description: 'Discover and recruit talented athletes' },
  { id: 'creator', name: 'Creator', description: 'Tournament directors, event directors, and content creators - stream and monetize your events' },
  { id: 'admin', name: 'Administrator', description: 'Full platform access - manage events, games, users, and system settings' },
];

// Mock data for Rooam Teams feature
export const mockTeams = [
  {
    id: 1,
    name: 'Eagles Basketball',
    sport: 'Basketball',
    season: '2025 Spring',
    coach: 'Coach John Smith',
    coachAvatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=CoachJohn',
    members: 15,
    logo: 'E',
    color: '#00d4ff',
    record: '12-3',
    nextGame: '2025-01-25T18:00:00',
    opponent: 'Hawks',
  },
  {
    id: 2,
    name: 'Thunderbolts Volleyball',
    sport: 'Volleyball',
    season: '2025 Spring',
    coach: 'Coach Sarah Martinez',
    coachAvatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=CoachSarah',
    members: 12,
    logo: 'T',
    color: '#ff0000',
    record: '10-5',
    nextGame: '2025-01-26T14:00:00',
    opponent: 'Lightning',
  },
];

export const mockTeamMembers = {
  1: [
    { id: 1, name: 'Noah Taylor', number: 1, position: 'Point Guard', avatar: 'https://customer-assets.emergentagent.com/job_a7dcc5ab-3efc-44f0-a3e2-af78bfda65b9/artifacts/fzm8g1k9_IMG_9784.jpeg', role: 'player', status: 'active' },
    { id: 2, name: 'Tyler Davis', number: 12, position: 'Shooting Guard', avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Tyler', role: 'player', status: 'active' },
    { id: 3, name: 'James Wilson', number: 34, position: 'Small Forward', avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=James', role: 'player', status: 'active' },
    { id: 4, name: 'Chris Brown', number: 5, position: 'Power Forward', avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Chris', role: 'player', status: 'injured' },
    { id: 5, name: 'David Lee', number: 44, position: 'Center', avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=David', role: 'player', status: 'active' },
    { id: 6, name: 'Coach John Smith', number: null, position: 'Head Coach', avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=CoachJohn', role: 'coach', status: 'active' },
    { id: 7, name: 'Mike Thompson', number: null, position: 'Parent', avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Mike', role: 'parent', status: 'active' },
  ],
  2: [
    { id: 1, name: 'Sarah Williams', number: 15, position: 'Outside Hitter', avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Sarah', role: 'player', status: 'active' },
    { id: 2, name: 'Emily Chen', number: 7, position: 'Setter', avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Emily', role: 'player', status: 'active' },
    { id: 3, name: 'Jessica Adams', number: 3, position: 'Libero', avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Jessica', role: 'player', status: 'active' },
    { id: 4, name: 'Coach Sarah Martinez', number: null, position: 'Head Coach', avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=CoachSarah', role: 'coach', status: 'active' },
  ],
};

export const mockTeamChat = {
  1: [
    { id: 1, senderId: 6, senderName: 'Coach John Smith', message: 'Great practice today everyone! Remember, tomorrow we have film session at 4pm.', timestamp: '2025-01-22T16:30:00', avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=CoachJohn' },
    { id: 2, senderId: 1, senderName: 'Noah Taylor', message: 'Thanks Coach! Should we bring our game notes?', timestamp: '2025-01-22T16:45:00', avatar: 'https://customer-assets.emergentagent.com/job_a7dcc5ab-3efc-44f0-a3e2-af78bfda65b9/artifacts/fzm8g1k9_IMG_9784.jpeg' },
    { id: 3, senderId: 6, senderName: 'Coach John Smith', message: 'Yes, please bring your notes. We\'ll be reviewing the Hawks game footage.', timestamp: '2025-01-22T16:50:00', avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=CoachJohn' },
    { id: 4, senderId: 2, senderName: 'Tyler Davis', message: 'Got it! Also, is Chris cleared to play Saturday?', timestamp: '2025-01-22T17:00:00', avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Tyler' },
    { id: 5, senderId: 6, senderName: 'Coach John Smith', message: 'Still waiting on the doctor\'s clearance. Will update everyone as soon as I know.', timestamp: '2025-01-22T17:05:00', avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=CoachJohn' },
    { id: 6, senderId: 7, senderName: 'Mike Thompson', message: 'Reminder: I\'m bringing snacks for Saturday\'s game 🍕', timestamp: '2025-01-22T18:30:00', avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Mike' },
  ],
  2: [
    { id: 1, senderId: 4, senderName: 'Coach Sarah Martinez', message: 'Practice cancelled tomorrow due to gym maintenance. Work on your serves at home!', timestamp: '2025-01-22T14:00:00', avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=CoachSarah' },
    { id: 2, senderId: 1, senderName: 'Sarah Williams', message: 'Thanks for letting us know Coach!', timestamp: '2025-01-22T14:15:00', avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Sarah' },
  ],
};

export const mockTeamSchedule = {
  1: [
    { id: 1, title: 'Practice', date: '2025-01-23', time: '16:00', duration: '2 hours', location: 'Main Gym', type: 'practice', rsvp: { yes: 12, no: 1, pending: 2 } },
    { id: 2, title: 'Film Session', date: '2025-01-23', time: '19:00', duration: '1 hour', location: 'Team Room', type: 'meeting', rsvp: { yes: 14, no: 0, pending: 1 } },
    { id: 3, title: 'Game vs Hawks', date: '2025-01-25', time: '18:00', duration: '2 hours', location: 'Metro Sports Arena', type: 'game', rsvp: { yes: 15, no: 0, pending: 0 }, opponent: 'Hawks' },
    { id: 4, title: 'Practice', date: '2025-01-27', time: '16:00', duration: '2 hours', location: 'Main Gym', type: 'practice', rsvp: { yes: 10, no: 2, pending: 3 } },
    { id: 5, title: 'Tournament - Day 1', date: '2025-02-01', time: '09:00', duration: '8 hours', location: 'Convention Center', type: 'tournament', rsvp: { yes: 15, no: 0, pending: 0 } },
  ],
  2: [
    { id: 1, title: 'Practice', date: '2025-01-24', time: '15:00', duration: '2 hours', location: 'Volleyball Courts', type: 'practice', rsvp: { yes: 10, no: 1, pending: 1 } },
    { id: 2, title: 'Game vs Lightning', date: '2025-01-26', time: '14:00', duration: '2 hours', location: 'Home Court', type: 'game', rsvp: { yes: 12, no: 0, pending: 0 }, opponent: 'Lightning' },
  ],
};

export const mockTeamActivity = {
  1: [
    { id: 1, type: 'game_result', title: 'Won vs Warriors', description: 'Final Score: 85-79', timestamp: '2025-01-20T21:00:00', icon: 'trophy' },
    { id: 2, type: 'highlight', title: 'Noah Taylor - 30 Point Game', description: 'New highlight clip available', timestamp: '2025-01-20T22:00:00', icon: 'video' },
    { id: 3, type: 'schedule', title: 'Practice Scheduled', description: 'Thursday 4pm at Main Gym', timestamp: '2025-01-21T10:00:00', icon: 'calendar' },
    { id: 4, type: 'roster', title: 'Injury Update', description: 'Chris Brown - Day-to-day (ankle)', timestamp: '2025-01-21T14:00:00', icon: 'alert' },
    { id: 5, type: 'announcement', title: 'Team Photo Day', description: 'Saturday before the game at 5pm', timestamp: '2025-01-22T09:00:00', icon: 'camera' },
  ],
  2: [
    { id: 1, type: 'game_result', title: 'Lost vs Strikers', description: 'Final Score: 2-3', timestamp: '2025-01-19T17:00:00', icon: 'trophy' },
    { id: 2, type: 'schedule', title: 'Practice Cancelled', description: 'Tomorrow - gym maintenance', timestamp: '2025-01-22T14:00:00', icon: 'calendar' },
  ],
};
